export { useIsBlankImage, hasPaintedSample } from './useIsBlankImage';
export type { BlankImageState } from './useIsBlankImage';
